window.theme = window.theme || {};

theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
}

theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
})();

class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.mainTabEls = this.querySelectorAll('[js-main-tab]');
    this.mainItemEls = this.querySelectorAll('[js-main-item]');
    this.bundleStatusEls = this.querySelectorAll("[js-bundle-status]");
    this.addBundleBtn = this.querySelectorAll("[js-add-bundle-btn]");
    this.variantFields = this.querySelectorAll("[js-variant-fields]");
    this.productsSelectionGrid = this.querySelectorAll("[js-products-selection-grid]");
    this.selectedProducts = [];
    this.bundleLimit = parseInt(this.getAttribute("data-bundle-limit"));
  }

  connectedCallback() {
    this.initSlider();
    this.initEvents();
  }

  initSlider() {
    new Swiper('[js-bundle-slider]', {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
    });
  }

  initEvents() {
    this.mainTabEls.forEach((tab, index) => {
      tab.addEventListener('click', () => this.updateActiveTab(index));
    });

    this.addEventListener('click', ({ target }) => {
      const collectionTab = target.hasAttribute('js-collection-tab');
      const productSwatch = target.hasAttribute('js-product-image-tab') ? target : target.closest('[js-product-image-tab]');

      let url;
      const mainPanel = this.querySelector("[js-main-item].is-active");
      if(collectionTab) {
        const collectionTabs = mainPanel.querySelectorAll("[js-collection-tab]");
        const collectionTabPanels = mainPanel.querySelectorAll("[js-collection-tab-panel]");
        const id = target.getAttribute("data-id");
        const activePanel = mainPanel.querySelector(`#${id}`);

        collectionTabs.forEach(el => el.classList.remove("is-active"));
        collectionTabPanels.forEach(el => el.classList.remove("is-active"));

        target.classList.add("is-active");
        activePanel?.classList.add("is-active");

        const selectedSwatchProduct = activePanel.querySelector("[js-product-image-tab].is-selected");

        url = selectedSwatchProduct.getAttribute("data-url");

        this.fetchProduct(mainPanel, url)
      }
      
      if(productSwatch) {
        const activePanel = mainPanel.querySelector(`[js-collection-tab-panel].is-active`);
        const swatchProducts = activePanel.querySelectorAll("[js-product-image-tab]");

        swatchProducts.forEach(t => t.classList.remove('is-selected'));
        productSwatch.classList.add('is-selected');

        url = productSwatch.getAttribute("data-url");
        this.fetchProduct(mainPanel, url)
      };

      if(target.hasAttribute("js-select-product-btn")) {
        const currentPanel = target.closest("[js-collection-tab-panel]");
        const panelIndex = parseInt(currentPanel.getAttribute("data-panel-index"));
        const featuredImage = target.getAttribute("data-featured-image");
        const variantId = target.getAttribute("data-variant-id");
        const variantPrice = parseFloat(target.getAttribute("data-variant-price"));
        const productId = target.getAttribute("data-product-id");

        this.selectedProducts[panelIndex] = {
          productId,
          variantId,
          featuredImage,
          variantPrice
        };

        const activeTab = mainPanel.querySelector("[js-collection-tab].is-active");
        const nonActiveTab = mainPanel.querySelector("[js-collection-tab]:not(.is-active):not(.is-selected)");

        activeTab.classList.add("is-selected");
        nonActiveTab?.click();

        this.updateBundleStatus();
        this.updateBundleBtn();
        this.handleVariantFields();
        this.updateProductsSelectionGrid();
      }
    });

    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  updateActiveTab(activeIndex) {
    this.mainTabEls.forEach(tab => tab.classList.remove('is-active'));
    this.mainItemEls.forEach(item => item.classList.remove('is-active'));

    this.mainTabEls[activeIndex].classList.add('is-active');
    this.mainItemEls[activeIndex].classList.add('is-active');

    this.selectedProducts = [];
    this.updateBundleStatus();
    this.updateBundleBtn();
    this.handleVariantFields();
    this.updateProductsSelectionGrid();

    const collectionTabs = this.querySelectorAll("[js-collection-tab]");
    const mainPanel = this.querySelector("[js-main-item].is-active");
    const defaultCollectionTab = mainPanel.querySelector("[js-collection-tab]");
    
    collectionTabs.forEach(el => el.classList.remove("is-selected"));
    defaultCollectionTab?.click();
  }

  fetchProduct(mainPanel, url) {
    const currentPanel = mainPanel.querySelector("[js-collection-tab-panel].is-active");
    const gallery = currentPanel.querySelector('[js-product-media-gallery]');
    const productInfo = currentPanel.querySelector('[js-product-info]');
    const productTitle = mainPanel.querySelector('[js-product-title]');
    productInfo.classList.add("is-loading");
    gallery.classList.add("is-loading");

    fetch(`${url}?section_id=bundle-builder-ajax`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const galleryAjax = doc.querySelector('[js-product-media-gallery]');
        const productInfoAjax = doc.querySelector('[js-product-info]');
        const productTitleAjax = doc.querySelector('[js-product-title]');
        
        if (galleryAjax && gallery) {
          gallery.innerHTML = galleryAjax.innerHTML;
        }
        if (productInfoAjax && productInfo) {
          productInfo.outerHTML = productInfoAjax.outerHTML;
        }
        if (productTitle && productTitleAjax) {
          productTitle.innerHTML = productTitleAjax.innerHTML;
        }
        
        this.initSlider();
      })
      .finally(() => {
        productInfo.classList.remove("is-loading");
        gallery.classList.remove("is-loading");
      })
      .catch(err => console.error('Fetch error:', err));
  }

  onVariantChange() {
    const mainPanel = this.querySelector("[js-main-item].is-active");
    const currentPanel = mainPanel.querySelector("[js-collection-tab-panel].is-active");
    const productInfo = currentPanel.querySelector('[js-product-info]');
    const selectedOptions = productInfo.querySelectorAll("[js-option-value-field]:checked");
    const variantsJson = JSON.parse(productInfo.querySelector("[js-variants-json]").textContent);

    const selectedVariant = variantsJson.find(variant => {
      return (
        (!variant.option1 || selectedOptions[0]?.value === variant.option1) &&
        (!variant.option2 || selectedOptions[1]?.value === variant.option2) &&
        (!variant.option3 || selectedOptions[2]?.value === variant.option3)
      );
    });

    this.renderProductVariantInfo(mainPanel, selectedVariant)

  }

  renderProductVariantInfo(mainPanel, currentVariant) {
    const currentPanel = mainPanel.querySelector("[js-collection-tab-panel].is-active");
    const productInfo = currentPanel.querySelector('[js-product-info]');
    productInfo.classList.add("is-loading");
    const url = `/products/${productInfo.getAttribute("data-handle")}?variant=${currentVariant.id}`;

    fetch(`${url}&section_id=bundle-builder-ajax`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productInfoAjax = doc.querySelector('[js-product-info]');
        
        if (productInfoAjax && productInfo) {
          productInfo.innerHTML = productInfoAjax.innerHTML;
        }
      })
      .finally(() => {
        productInfo.classList.remove("is-loading");
      })
      .catch(err => console.error('Fetch error:', err));
  }

  updateBundleStatus() {
    let totalPrice = 0;
    this.selectedProducts.forEach(p => {
      totalPrice += p.variantPrice;
    });

    this.bundleStatusEls.forEach(el => {
      if(this.selectedProducts.length) {
        el.innerHTML = `Bundle: ${this.selectedProducts.length} of ${this.bundleLimit} products, ${theme.Currency.formatMoney(totalPrice, theme.settings.moneyFormat)}`;
        el.classList.remove("is-disabled");
      }else {
        el.innerHTML = `Bundle: Select Products`;
        el.classList.add("is-disabled");
      }
    });
  }

  updateBundleBtn() {
    this.addBundleBtn.forEach(el => {
      if(this.selectedProducts.length === this.bundleLimit) {
        el.removeAttribute("disabled");
      }else {
        el.setAttribute("disabled", "disabled");
      }
    })
  }

  updateProductsSelectionGrid() {
    this.productsSelectionGrid.forEach(el => {
      if(this.selectedProducts.length) {
        const productSelectionHtml = this.selectedProducts
          .map(el => {
            return `<div class="bundle-section_product-img">
                      <img src="${el.featuredImage}" alt="" width="120" height="180">
                    </div>`;
          })
          .join("");

        el.innerHTML = productSelectionHtml
      }else {
        el.innerHTML = ""
      }
    })
  }

  handleVariantFields() {
    this.variantFields.forEach(el => {
      if (this.selectedProducts.length) {
        const fieldsHtml = this.selectedProducts
          .map((el, index) => {
            return `<input type="hidden" name="items[${index}][id]" value="${el.variantId}">`;
          })
          .join("");

        el.innerHTML = fieldsHtml;
      } else {
        el.innerHTML = "";
      }
    })
  }
}

customElements.define('bundle-builder', BundleBuilder);
